import { AbstractValidator } from './abstract-validator';

export class EmailValidator extends AbstractValidator {

    static getIdentifier(){
        return 'email';
    }

    static isApplicable(input) {
        return super.isApplicable(input)
            && input.tagName === 'INPUT'
            && input.hasAttribute('type')
            && input.getAttribute('type') === 'email';
    }

    static validate(input) {
        return (onError, onSuccess) => {
            const value = input.value;
            if (!value) {
                onSuccess();
            } else {
                const Regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
                if (Regex.test(value)) {
                    onSuccess();
                } else {
                    onError();
                }
            }
        };
    }
}